import ReactCountryFlag from 'react-country-flag';
import { Flag } from '../components/types';
import {
  CountryCodes,
  CurrencyType,
  SupportedCurrencies,
} from 'gmd-utilities-package';

const getFlagCodes = (): { [key: string]: string } => {
  let codes: { [key: string]: string } = {};
  for (const [key, value] of Object.entries(CountryCodes)) {
    codes[key] = value;
  }
  return codes;
};

export const flagCodes = getFlagCodes();

const sourceCountries: Flag[] = [
  {
    icon: <ReactCountryFlag countryCode={CountryCodes.cad} svg />,
    value: CurrencyType.CanadaianDollar.toLowerCase(),
    label: SupportedCurrencies[CurrencyType.CanadaianDollar].displayLabel,
  },
  {
    icon: <ReactCountryFlag countryCode={CountryCodes.usd} svg />,
    value: CurrencyType.UnitedStatesDollar.toLowerCase(),
    label: SupportedCurrencies[CurrencyType.UnitedStatesDollar].displayLabel,
  },
  {
    icon: <ReactCountryFlag countryCode={CountryCodes.gbp} svg />,
    value: CurrencyType.GreatBritainPound.toLowerCase(),
    label: SupportedCurrencies[CurrencyType.GreatBritainPound].displayLabel,
  },
];

const destinationCountries: Flag[] = [
  {
    icon: <ReactCountryFlag countryCode={CountryCodes.xaf} svg />,
    value: CurrencyType.CameroonianXAF.toLowerCase(),
    label: SupportedCurrencies[CurrencyType.CameroonianXAF].displayLabel,
  },
  {
    icon: <ReactCountryFlag countryCode={CountryCodes.cdf} svg />,
    value: CurrencyType.CongoCDF.toLowerCase(),
    label: SupportedCurrencies[CurrencyType.CongoCDF].displayLabel,
  },
];

export const getSourceCurrencies = () => {
  return sourceCountries;
};

export const getDestinationCurrencies = () => {
  return destinationCountries;
};

export const getDestinationCurrency = (currency: string) => {
  return destinationCountries.find((x) => x.value === currency);
};

export const transferOptions = [
  {
    value: 'CONSTRUCTION',
    label: 'Construction',
  },
  {
    value: 'EDUCATION',
    label: 'Education',
  },
  {
    value: 'FAMILY',
    label: 'Family',
  },
  {
    value: 'FUNERAL',
    label: 'Funeral',
  },
  {
    value: 'HEALTHCARE',
    label: 'Healthcare',
  },
  {
    value: 'SERVICE',
    label: 'Service',
  },
  {
    value: 'OTHER',
    label: 'Other',
  },
];

export const getTenantTypes = () => {
  return [
    {
      value: 'inhouse',
      label: 'InHouse',
    },
    {
      value: 'independent',
      label: 'Independent',
    },
  ];
};
